import { Box } from "@outschool/backpack";
import { Trans, useTranslation } from "@outschool/localization";
import { ExternalLink, TrackedButton } from "@outschool/ui-components-shared";
import React from "react";

import VideoModal from "../VideoModal";

const MUX_PLAYBACK_ID_TIPS_FOR_TEACHING = "nzshQs8SxewfAKZzPpwnJA7BIyzZ1kL8";

export default function TipsForTeachingOnlineClasses() {
  const [isOpen, setIsOpen] = React.useState(false);
  const { t } = useTranslation(
    "client\\components\\classroom\\TipsForTeachingOnlineClasses",
  );
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <>
      <TrackedButton
        variant="link"
        onClick={openModal}
        trackingUniqueId="teacher_how_it_works"
        trackingName="teacher_how_it_works"
        trackingSharedProperties={{
          videoId: MUX_PLAYBACK_ID_TIPS_FOR_TEACHING,
        }}
      >
        {t("Watch now: Tips for teaching live online classes...")}
      </TrackedButton>
      <VideoModal
        open={isOpen}
        onClose={closeModal}
        videoPlaybackID={MUX_PLAYBACK_ID_TIPS_FOR_TEACHING}
      >
        <Box
          sx={{
            paddingX: "1em",
          }}
        >
          <Trans t={t}>
            See more{" "}
            <ExternalLink url="https://support.outschool.com/en/articles/452599-teaching-live-online-classes">
              tips for teaching live online classes{" "}
            </ExternalLink>
            in the help center.
          </Trans>
        </Box>
      </VideoModal>
    </>
  );
}
